import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import LoadingSpinner from "../components/newComp/LoadingSpinner";
import Layout from "../layout/Layout";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, authInitialized } = useSelector((state) => state.auth);

  // Don't render anything until authentication check is complete
  if (!authInitialized) {
    return <LoadingSpinner />; // or return null if you don't want a spinner
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Layout sx={{ display: "flex" }}>{children}</Layout>;
};

export default ProtectedRoute;
